import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getNotifications,
  getUnreadCount,
  markRead,
  markAllRead,
} from "../services/notifications.service";

export function useNotifications(token) {
  return useQuery({
    queryKey: ["notifications", token],
    queryFn: () => getNotifications(token),
    enabled: !!token,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

export function useUnreadCount(token) {
  return useQuery({
    queryKey: ["notificationsUnread", token],
    queryFn: () => getUnreadCount(token),
    enabled: !!token,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

export function useMarkRead(token) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => markRead(id, token),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notifications"] });
      qc.invalidateQueries({ queryKey: ["notificationsUnread"] });
    },
  });
}

export function useMarkAllRead(token) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => markAllRead(token),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["notifications"] });
      qc.invalidateQueries({ queryKey: ["notificationsUnread"] });
    },
  });
}
